import "rc-dialog/assets/index.css";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import PinPadView from "./PinPadView";
import { isResultOk, preValidatePin } from "./pinValidation";

export type PinValidationStatus =
    | "PIN_LENGTH_ERROR"
    | "PIN_INVALID"
    | "PIN_OK"
    | "PIN_TOO_SIMPLE"
    | "PIN_RETRY_REACHED"
    | "PIN_VERIFIED"
    | "PIN_CHANGE_ERROR"
    | "PIN_LOGIN_ERROR";

export interface PinPadState {
    readonly pinValue: string;
    readonly preValidationStatus?: PinValidationStatus;
    readonly preValidationTimestamp?: number;
}

export interface PinPadProps {
    readonly onNewPin: (newPin: string) => void;
    readonly validationResult?: PinValidationStatus;
    readonly validationTimestamp?: number;
    readonly needsPreValidation: boolean;
}

export class PinPad extends React.Component<
    PinPadProps & RouteComponentProps,
    PinPadState
> {
    constructor(props: PinPadProps & RouteComponentProps) {
        super(props);
        this.state = {
            pinValue: ""
        };
    }

    public render() {
        return (
            <PinPadView
                pinValue={this.state.pinValue}
                lastSubmitTimestamp={this.lastSubmitTimestamp}
                submit={this.submitPin}
                pinChange={this.pinChange}
                validationStatus={this.validationMessage}
            />
        );
    }
    private get validationMessage(): PinValidationStatus | undefined {
        return this.props.needsPreValidation
            ? this.state.preValidationStatus || this.props.validationResult
            : this.props.validationResult;
    }

    private get lastSubmitTimestamp(): number {
        return Math.max(
            this.props.validationTimestamp || 0,
            this.state.preValidationTimestamp || 0
        );
    }

    private pinChange = (pinValue: string) =>
        this.setState({
            pinValue
        });

    private submitPin = () => {
        if (this.props.needsPreValidation) {
            const preValidationStatus = preValidatePin(this.state.pinValue);
            if (!isResultOk(preValidationStatus)) {
                this.setState({
                    preValidationStatus,
                    preValidationTimestamp: new Date().getTime()
                });
                return;
            }
        }
        this.setState({
            preValidationStatus: undefined,
            preValidationTimestamp: undefined
        });
        this.props.onNewPin(this.state.pinValue);
    };
}

export default withRouter(PinPad);
